import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';

import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

const PartnerSourceView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useSendCommunicationModal();

  return (
    <div className="row">
      <div className="form-group col-12 col-md-6">
        <label className="form-label" htmlFor="partner-selector">
          {t('SelectPartners')}
        </label>

        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="partner-selector"
            onChange={() => {}}
            onFetchData={actions.handleSearchPartnerByTerm}
            placeholder={t('SearchPartner')}
            minimumInputLength={3}
            defaultOptions={data.partnerOptions}
            noDataLabelKey="NoPartnersHaveBeenFound"
            loadingLabelKey="LoadingPartners"
            errorLabelKey="ErrorLoadingPartners"
            className="react-select-lg"
            closeMenuOnSelect={false}
            isMultiple
            selectedItems={data.selectedRecipientOptions}
            onAddItem={actions.handleAddRecipient}
            isDisabled={!!data.selectedPartnerCategoryOption}
          />
        </div>
      </div>

      <div className="form-group col-12 col-md-6">
        <label className="form-label" htmlFor="category-selector">
          {t('FilterByCategory')}
        </label>

        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="category-selector"
            value={data.selectedPartnerCategoryOption}
            onChange={actions.handleChangeCategory}
            onFetchData={() => Promise.resolve(data.partnerCategoryOptions)}
            placeholder={t('SearchCategory')}
            minimumInputLength={3}
            defaultOptions={data.partnerCategoryOptions}
            noDataLabelKey="NoCategoriesHaveBeenFound"
            loadingLabelKey="LoadingCategories"
            errorLabelKey="ErrorLoadingCategories"
            className="react-select-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default PartnerSourceView;
